/* file description */

import type { UseColumnsState } from './type';

export const useColumnsState: UseColumnsState = ({ columnsState, defaultColumnsState }) => {
  return (
    columnsState ?? {
      defaultValue: defaultColumnsState,
      onChange: (val: any) => {
        console.log('defaultColumnsState', val);
      },
    }
  );
};
